import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {RestService} from "../../core/services/rest.service";
import {NBS} from "../../../classes/nbs";

@Injectable()
export class VinculoNBSAtividadeNacionalService {

  constructor(private restService: RestService){
  }

  buscarNBSPorAtividadeNacional(atividadeNacional: number): Observable<NBS[]> {
    return this.restService.get("/vinculonbsatividadenacional/nbs/"+ atividadeNacional, {responseType: NBS});
  }

}
